import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Icon = ({ name, ...props }) => {
    const filterProps = useCallback(() => {
        let filteredProps = {};

        Object.keys(props).map(key => {
            if (key.search(/^data-|^on/i) === 0) {
                filteredProps[key] = props[key];
            }
        });

        return filteredProps;
    }, [props]);

    return (
        <span
            className={classnames({
                'fa': true,
                [name]: true
            })}
            {...filterProps()}
        />
    );
};

Icon.propTypes = {
    name: PropTypes.string
};

Icon.defaultProps = {
    name: ''
};

export default Icon;
